import {apiGet, apiPost, apiPut, apiDelete, apiPatch} from '@/utils/request'

/**
* 获取云因文字列表
*
* @link http://yapi.acagrid.com/project/29/interface/api/1412
*
* @author Pandex
*/
export function getRewardArticles() {
  return apiGet('/promote/reward/articles')
}

/**
 * 阅读量兑换积分
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1430
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function requestExchangeReward() {
  return apiPost('/promote/reward/exchange_reward')
}

/**
 * 记录访问数据
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1421
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function recordVisit(id, u) {
  return apiPost('/promote/reward/articles/:id/log_visit', {id ,u}, false, true)
}

/**
 * 获取班级使用报告
 * @link http://yapi.acagrid.com/project/29/interface/api/1529
 * 
 * @param  int id [班级id]
 * @return Promise
 *
 * @author vincent.row
 */
export function getClassReport(id) {
  return apiGet('/promote/class/:id/report', {id: id})
}


/**
 * 翻盘抽奖 - 获取预分配中奖结果
 * @link http://yapi.acagrid.com/project/29/interface/api/1538
 * 
 * @return Promise
 *
 * @author vincent.row
 */
export function getLotteryPreAward() {
  return apiGet('/promote/lottery/get_award')
}

/**
 * 翻盘抽奖 - 获取抽奖活动统计数据
 * @link http://yapi.acagrid.com/project/29/interface/api/1574
 * 
 * @return Promise
 *
 * @author vincent.row
 */
export function getLotteryStats() {
  return apiGet('/promote/lottery/stats')
}

/**
 * 翻盘抽奖 - 获取预分配中奖结果
 * @link http://yapi.acagrid.com/project/29/interface/api/1547
 *
 * @param int awardId [奖励id]
 * @return Promise
 *
 * @author vincent.row
 */
export function recordLotteryAward(awardId) {
  return apiPost('/promote/lottery/record_award',{award_id: awardId})
}

/**
 * 翻盘抽奖 - 获取中奖结果
 * @link http://yapi.acagrid.com/project/29/interface/api/1547
 *
 * @param int awardId [奖励id]
 * @return Promise
 *
 * @author vincent.row
 */
export function getLotteryEarnings(awardId) {
  return apiGet('/promote/lottery/earnings')
}

/**
 * 翻盘抽奖 - 转发后增加抽奖次数
 * @link http://yapi.acagrid.com/project/29/interface/api/1547
 *
 * @param string scene [分享场景]
 * @return Promise
 *
 * @author vincent.row
 */
export function shareAddLotteryChances(scene) {
  return apiPost('/promote/lottery/add_chances',{scene: scene}, false, true)
}

/**
 * 获取班级阶段水滴/红花排行榜
 * @link http://yapi.acagrid.com/project/29/interface/api/1746
 *
 * @param int id 班级id
 * @param string period 阶段：学期(semester)，月(month)，周(week)
 * @return Promise
 *
 * @author vincent.row
 */
export function getClassDropsRank(id, period) {
    return apiGet('/promote/class/:id/drops_rank',{period,id})
}

/**
 * 排行榜 - 学生阶段水滴/红花"本周"周榜
 * @link http://yapi.acagrid.com/project/29/interface/api/3205
 */
export function getClassWeekDropsRank(id) {
  return apiGet(`/promote/class/${id}/drops_week_rank`)
}

/**
 * 排行榜 - 根据水滴/红花榜单ID获取榜单详细排名
 * @link http://yapi.acagrid.com/project/29/interface/api/3285
 */
export function getDropsRankList(id, page) {
  return apiGet(`/promote/class/${id}/drops_ranks`, {page})
}

/**
 * 排行榜 - 根据水滴/红花榜单ID获取榜单详细排名
 * @link http://yapi.acagrid.com/project/29/interface/api/3285
 */
export function getDropsRankById(class_id, rank_id) {
  return apiGet(`/promote/class/${class_id}/drops_rank/${rank_id}`)
}

/**
 * 红花榜 - 根据周总榜ID获取班级科目榜列表
 * @link http://yapi.acagrid.com/project/29/interface/api/3565
 */
export function getDropsSubjectRankById(class_id, rank_id) {
  return apiGet(`/promote/class/${class_id}/drops_week_subject_ranks`, {rank_id})
}

/**
 * 红花榜 - 根据科目榜ID获取科目榜详细信息
 * @link http://yapi.acagrid.com/project/29/interface/api/3573
 */
export function getDetailDropsSubjectRankById(class_id, rank_id) {
  return apiGet(`/promote/class/${class_id}/drops_subject_rank/${rank_id}`)
}

/**
 * 学生评语 - 获取学生评语配置
 * @link http://yapi.acagrid.com/project/29/interface/api/2549
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getStudentsComments(partner) {
  return apiGet('/promote/student_comment_config', {partner})
}

/**
 * 学生评语 - 批量创建学生评语接口
 * @link http://yapi.acagrid.com/project/29/interface/api/2541
 *
 * @return Promise
 *
 * @author Pandex
 */
export function postCreateComments(students, refer_user_id, class_id) {
  return apiPost('/promote/create_student_comments', {students, refer_user_id, class_id})
}

/**
 * 学生评语 - 获取学生评语成功邀请用户数据
 * @link http://yapi.acagrid.com/project/29/interface/api/2581
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getCommentsInviteData() {
  return apiGet('/promote/student_comment/invited_users')
}


/**
 * 学生评语 - 判断用户是否已经完成产品体验
 * @link http://yapi.acagrid.com/project/29/interface/api/2597
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getCommentsUserFinished() {
  return apiGet('/promote/student_comment/is_user_finished')
}
/**
 * 临时链接兑换红花接口
 * @link http://yapi.acagrid.com/project/29/interface/api/2925
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getPromoteFlower(token) {
  return apiGet('/promote/claim_link_flower', {token})
}
/**
 * 临时链接兑换水滴接口
 * @link http://yapi.acagrid.com/project/29/interface/api/5021
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getPromoteDrops(token) {
  return apiGet('/promote/claim_survey_drops', {token}, true, true)
}
/**
 * 教师加群合法性检测接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3133
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getValidJoinGroup() {
  return apiGet('/teacher/join_group_check')
}

/**
 * 动态内容 - 获取当前用户广告banner
 * @link http://yapi.acagrid.com/project/29/interface/api/3461
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getPromoteBanners() {
  return apiGet('/promote/banners')
}

/**
 * 每日报告 - 获取每日post学生表现报告接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3485
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getDailyPostReport(date) {
  return apiGet('/promote/daily_post_report', {date})
}

/**
 * 每日报告 - 根据每日post报告奖励学生接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3485
 *
 * @return Promise
 *
 * @author Pandex
 */
export function postDailyPostReport({high_score_students, high_score_flowers, active_students, active_flowers}) {
  return apiPost('/promote/daily_post_report_reward', {high_score_students, high_score_flowers, active_students, active_flowers})
}
/**
 * 每日报告 - 获取每日红花奖励报告接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3501
 *
 * @return Promise
 *
 * @author Pandex
 */
export function getFlowerReport(id) {
  return apiGet('/promote/flower_report/:id', {id})
}

/**
 * 安排他班post - 创建安排他班post任务接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3725
 */
export function createInviteClassPost(params = {
  grade_id: '',
  class_no: '',
  student_count: '',
  object_id: '',
  post_type: '',
  subject_id: '',
  post_json_data: null,
}) {
  return apiPost('/promote/create_invite_class_post', params)
}

/**
 * 安排他班post - 根据ID获取安排post任务信息
 * @link http://yapi.acagrid.com/project/29/interface/api/3733
 */
export function getInviteClassPostById(id) {
  return apiGet(`/promote/invite_class_posts/${id}`)
}
/**
 * 安排他班post - 获取临时关注二维码
 * @link http://yapi.acagrid.com/project/29/interface/api/3701
 */
export function getInviteClassPostQrcode(id) {
  return apiGet(`/promote/invite_class_post/subscribe_qrcode`, {id})
}
/**
 * 安排他班post - 班主任确认安排post接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3709
 */
export function confirmInviteClassPost(id) {
  return apiPut(`/promote/confirm_invite_class_post/${id}`)
}
/**
 * 安排他班post - 班主任拒绝安排接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3717
 */
export function rejectInviteClassPost(id) {
  return apiPut(`/promote/reject_invite_class_post/${id}`)
}

/**
 * 安排他班post - 班主任拒绝安排接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3853
 */
export function startDwonloadComment(token) {
  return apiPost('/promote/download_student_comment', {token})
}
/**
 * 创建分享文件接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3885
 */
export function shareFiles(name, url) {
  return apiPost(`/post/share_files`, {
    name,
    url
  })
}
/**
 * 获取分享文件接口
 * @link http://yapi.acagrid.com/project/29/interface/api/3893
 */
export function getShareFile(token) {
  return apiGet(`/post/share_file`, {
    token
  })
}
/**
 * 获取短链接接口
 * @link http://yapi.acagrid.com/project/29/interface/api/1706
 */
export function getShortUrl(url) {
  return apiPost(`/system/short_url`, {
    url
  }, false, true)
}

/**
 * 红包抽奖 - 获取抽奖活动统计
 * @link http://yapi.acagrid.com/project/29/interface/api/4861
 * 
 * @return Promise
 *
 * @author Pandex
 */
export function getRedpackLotteryStats(token) {
  //code为-201为活动失效，code为-202代表未满足参加条件
  return apiGet('/promote/redpack_lottery/stats', {token})
}

/**
 * 红包抽奖 - 获取预分配中奖结果
 * @link http://yapi.acagrid.com/project/29/interface/api/4853
 * 
 * @return Promise
 *
 * @author Pandex
 */
export function getRedpackLotteryPreAward(token) {
  return apiGet('/promote/redpack_lottery/get_award', {token}, true)
}

/**
 * 红包抽奖 - 确认/记录中奖结果接口
 * @link http://yapi.acagrid.com/project/29/interface/api/4869
 *
 * @param int awardId [奖励id]
 * @return Promise
 *
 * @author Pandex
 */
export function recordRedpackLotteryAward(amount, token) {
  return apiPost('/promote/redpack_lottery/record_award', {amount, token}, false, true)
}

/**
 * 安排他班post - 获取被邀请人确认建班后临时关注二维码
 * @link http://yapi.acagrid.com/project/29/interface/api/4965
 */
 export function getAssignClassAcceptQrcode(id) {
  return apiGet('/promote/invite_class_post/confirmed_subscribe_qrcode', {id})
}



// WEBPACK FOOTER //
// ./src/api/promote.js